import { Constants } from '../_constants/shared.constants';
export const  successLoader=(data)=> {
     return{ type: Constants.loader.LOADER_REQUESTER,data }
     }
  